import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useCompleteForm from "../../../../hooks/useCompleteForm";
import validators from "../../../../utils/validators";
import { actions } from "../../../../actions/clientes.actions";
import DadosOutrasInformacoesDefaultForm from "./DadosOutrasInformacoesDefaultForm";
import {
  getPreenchimentoCliente,
  isEnviandoPreenchimentoCliente,
  isGravandoPreenchimentoCliente,
} from "../../../../selectors/clientes.selectors";
import { transformToDate } from "../../../../utils/basic";

const DadosOutrasInformacoesDefaultFormConnected = ({
  handleGoTo0,
  events,
  comprador,
  setComprador,
  ...props
}) => {
  const dispatch = useDispatch();
  const {
    cliente: clienteData,
    dominios: { perfilRenda: perfisRenda, profissao: profissoes },
    validacao,
  } = useSelector(getPreenchimentoCliente);
  const sending = useSelector(isEnviandoPreenchimentoCliente);
  const submitting = useSelector(isGravandoPreenchimentoCliente);

  const cliente = {
    ...clienteData,
    fluxo: validacao.completa.cliente,
  };

  const callback = useCallback(() => {
    handleGoTo0();
  }, [handleGoTo0]);

  const resetValues = useCallback(
    () => ({
      ppe: null,
      usPerson: null,
      residenciaFiscalBrasil: null,
      renda: null,
      perfilRenda: null,
      patrimonio: null,
      renda: null,
      perfilRenda: null,
      ...cliente,
      dadosProfissionais: {
        profissao: null,
        cargo: null,
        nomeEmpresa: null,
        dataAdmissao: null,
        ...cliente.dadosProfissionais,
      },
    }),
    [comprador]
  );

  const [formProps, handleSubmit] = useCompleteForm({
    rules: () => ({
      ppe: validators.object({ required: true }),
      usPerson: validators.object({ required: true }),
      residenciaFiscalBrasil: validators.object({ required: true }),
      renda: validators.number({ required: true }),
      perfilRenda: validators.object({ required: true }),
      patrimonio: validators.number({ required: true }),
      dadosProfissionais: {
        profissao: validators.object({ required: true }),
        cargo: validators.string({ required: true }),
        nomeEmpresa: validators.string({ required: true }),
        dataAdmissao: validators.date({ required: true }),
      },
      renda: validators.number({ required: true }),
      perfilRenda: validators.object({ required: true }),
    }),
    initialValues: resetValues,
    handleSubmit: useCallback(
      (values) => {
        dispatch(
          actions.gravarPreenchimento.request({
            callback,
            passo: "outras-informacoes",
            cliente: {
              id: cliente.id,
              ppe: values.ppe,
              usPerson: values.usPerson,
              residenciaFiscalBrasil: values.residenciaFiscalBrasil,
              renda: values.renda,
              idPerfilRenda: values.perfilRenda?.id,
              patrimonio: values.patrimonio,
              dadosProfissionais: {
                idProfissao: values.dadosProfissionais.profissao?.id,
                dataAdmissao: transformToDate(
                  values.dadosProfissionais?.dataAdmissao
                ),
                cargo: values.dadosProfissionais?.cargo,
                nomeEmpresa: values.dadosProfissionais?.nomeEmpresa,
              },
            },
          })
        );
      },
      [callback, cliente, dispatch]
    ),
  });

  const { reset } = formProps;

  useEffect(() => {
    reset(resetValues());
  }, [perfisRenda, comprador, resetValues, reset]);

  return (
    <DadosOutrasInformacoesDefaultForm
      {...props}
      perfisRenda={perfisRenda}
      fluxo={cliente.fluxo}
      events={events}
      formProps={formProps}
      handleSubmit={handleSubmit}
      submitting={submitting}
      profissoes={profissoes}
    />
  );
};

export default DadosOutrasInformacoesDefaultFormConnected;
